var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex align-center background-auth",
      staticStyle: { height: "100vh" },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "mx-auto text-left pa-8 bgPanel",
          attrs: { width: 480, flat: "", align: "center", justify: "center" },
        },
        [
          _c("v-col", { staticClass: "text-center pa-0 mt-2 mb-6" }, [
            _c("img", {
              attrs: {
                src: require(`@/assets/appBrand--ax-full.svg`),
                width: "211",
              },
            }),
            _c(
              "span",
              {
                staticClass:
                  "mt-2 d-block subtitle-1 grey-500--text font-weight-bold",
              },
              [_vm._v("Restablecer contraseña")]
            ),
            _c("span", { staticClass: "mt-2 d-block body-1 grey-500--text" }, [
              _vm._v("Escribe tu nueva contraseña para iniciar sesión."),
            ]),
          ]),
          _c("span", { staticClass: "text-body-2 text-grey-500" }, [
            _vm._v("Contraseña"),
          ]),
          _c("v-text-field", {
            staticClass: "icon-field",
            attrs: {
              error: _vm.$v.user.new_password1.$error,
              "append-icon": _vm.show1 ? "mdi-eye" : "mdi-eye-off",
              type: _vm.show1 ? "user.new_password1" : "password",
              outlined: "",
              "hide-details": "",
              required: "",
              "single-line": "",
              dense: "",
              maxlength: "20",
              autocomplete: "new-password",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.resetPassword.apply(null, arguments)
              },
              "click:append": function ($event) {
                _vm.show1 = !_vm.show1
              },
            },
            model: {
              value: _vm.user.new_password1,
              callback: function ($$v) {
                _vm.$set(_vm.user, "new_password1", $$v)
              },
              expression: "user.new_password1",
            },
          }),
          _c(
            "span",
            { staticClass: "d-block mt-5 text-body-2 text-grey-500" },
            [_vm._v("Contraseña")]
          ),
          _c("v-text-field", {
            staticClass: "icon-field",
            attrs: {
              error: _vm.$v.user.new_password2.$error,
              "append-icon": _vm.show ? "mdi-eye" : "mdi-eye-off",
              type: _vm.show ? "user.new_password2" : "password",
              outlined: "",
              "hide-details": _vm.$v.user.new_password2.sameAsPassword,
              "persistent-hint": "",
              required: "",
              "single-line": "",
              dense: "",
              maxlength: "20",
              autocomplete: "new-password",
              hint: "El password debe ser igual.",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.resetPassword.apply(null, arguments)
              },
              "click:append": function ($event) {
                _vm.show = !_vm.show
              },
            },
            model: {
              value: _vm.user.new_password2,
              callback: function ($$v) {
                _vm.$set(_vm.user, "new_password2", $$v)
              },
              expression: "user.new_password2",
            },
          }),
          _c(
            "v-btn",
            {
              staticClass: "mt-13 mb-2",
              attrs: {
                loading: _vm.createLoader,
                color: "grey-900",
                dark: "",
                block: "",
              },
              on: { click: _vm.resetPassword },
            },
            [_vm._v("Restablecer contraseña")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }